import { Button, Select, SelectItem } from "@prismicio/editor-ui"

export type FieldSelectTypes = "web" | "document" | "media"

interface Props {
  hasLink: boolean
  onUnlink: () => void
  selectedType?: FieldSelectTypes
  selectEnabled: boolean
  onValueChange: (newValue: FieldSelectTypes) => void
  openInNewTab?: boolean
  setOpenInNewTab?: (open: boolean) => void
}

export function LinkFieldActions(props: Props) {
  const {
    hasLink,
    onUnlink,
    selectEnabled,
    selectedType,
    onValueChange,
    openInNewTab = true,
    setOpenInNewTab
  } = props

  const showNewTabButton = setOpenInNewTab && selectedType === "web"
  const checkBoxName = openInNewTab ? "checkBox" : "checkBoxOutlinedBlank"

  return (
    <>
      {showNewTabButton && (
        <Button
          startIcon={checkBoxName}
          color="grey"
          size="small"
          onClick={() => setOpenInNewTab(!openInNewTab)}
        >
          Open in new tab
        </Button>
      )}
      <Select
        value={selectedType}
        color="grey"
        size="small"
        boldTriggerText
        startIcon={getIcon(selectedType)}
        disabled={!selectEnabled}
        onValueChange={onValueChange}
        placeholder="Choose link type"
      >
        <SelectItem value="web" icon="public">
          Link to web page
        </SelectItem>
        <SelectItem value="document" icon="description">
          Link to Prismic page
        </SelectItem>
        <SelectItem value="media" icon="image">
          Link to media
        </SelectItem>
      </Select>

      <Button
        startIcon="close"
        color="grey"
        size="small"
        disabled={!hasLink}
        onClick={onUnlink}
      />
    </>
  )
}

function getIcon(type?: FieldSelectTypes) {
  if (!type) return undefined

  switch (type) {
    case "document":
      return "description"
    case "web":
      return "public"
    case "media":
      return "image"
  }
}
